/*
 * Copyright (c) 2021.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import axios from "axios";

$(function(){
    function initNewsletter() {
        const $section = $('.section-newsletter');
        if(!$section.length){
            return;
        }

        let $form = $section.find('form');

        $form.submit(function (e) {
            e.preventDefault();

            let data = $(this).data('yiiActiveForm');
            if (data && typeof data.validated!=='undefined' && !data.validated) {
                return false;
            }

            axios.post($form.attr('action') ? $form.attr('action') : '/carsell/utils/newsletter-add-subscriber', $form.serialize(), {
                params: {
                    from: $.address.value()
                }
            })
                .then(function (response) {
                    if(typeof response.data.success==='undefined' || !response.data.success){
                        return;
                    }

                    $section.find('.step-form').slideUp();
                    $section.find('.step-success').slideDown();
                });
        });
    }

    initNewsletter();
});
